import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import './App.css';
import Login from './pages/login';
import Dashboard from './pages/dashboard';
import CreateService from './pages/createService';
import CreateAccount from './pages/createAccount';
import CreateFastService from './pages/createFastService';
import OrdersOfServices from './pages/ordersOfServices';
import NavBar from './components/navigation';
import Clients from './pages/clients';
import ContextProvider from './utils/ContextProvider';
import OrderPage from './pages/order';
import Client from './pages/client';
import Agenda from './pages/schedule';
import ChecklistPage from './pages/detailedChecklist';
import ManageChecklistItems from './pages/checklistSettings';
import CookieBanner from './components/CookieBanner';
import PrivacyPolicy from './pages/privacyPolicy';
import StatisticsDashboard from './pages/report';
import ServiceItemsPage from './pages/serviceItemPage';
import Users from './pages/users';
import EditUser from './pages/editUser';
import ClientQuotePage from './pages/clientQuotePage';
import ManageParametersPage from './pages/Parameters';
import AwaitingPurchases from './pages/serviceWorkAttribution';
import BossApproval from './pages/bossApproval';
import BossApprovalReview from './pages/bossApprovalReview';
import NotificationsPage from './pages/notifications';

// Resets the window scroll position whenever the route changes,
// so users always land at the top of a new page instead of
// inheriting the previous page's scroll.
function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' in document.documentElement.style ? 'instant' : 'auto' });
  }, [pathname, search]);
  return null;
}

function App() {
  return (

    <BrowserRouter>
      <ContextProvider>
        <ScrollToTop />
        <div className="flex flex-col bg-neutral-100">
          <NavBar />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/create/service" element={<CreateService />} />
            <Route path="/create/fast-service" element={<CreateFastService />} />
            <Route path="/services" element={<OrdersOfServices />} />
            <Route path="/create/account" element={<CreateAccount />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/pending/assignments" element={<AwaitingPurchases />} />
            <Route path="/order" element={<OrderPage />} />
            <Route path="/manage/parameters" element={<ManageParametersPage />} />
            <Route path="/manage/users" element={<Users />} />
            <Route path="/manage/user" element={<EditUser />} />
            <Route path="/client" element={<Client />} />
            <Route path="/client/quote" element={<ClientQuotePage />} />
            <Route path="/schedule" element={<Agenda />} />
            <Route path="/serviceItem" element={<ServiceItemsPage />} />
            <Route path="/manage/checklist" element={<ManageChecklistItems />} />
            <Route path="/checklist" element={<ChecklistPage />} />
            <Route path="/politica-de-privacidade" element={<PrivacyPolicy />} />
            <Route path="/statistics" element={<StatisticsDashboard />} />
            <Route path="/boss/approvals" element={<BossApproval />} />
            <Route path="/boss/approval/review" element={<BossApprovalReview />} />
            <Route path="/notifications" element={<NotificationsPage />} />



            <Route path="*" element={<Login />} />
          </Routes>
          <CookieBanner /> {/* Add here, below Routes */}
        </div>
      </ContextProvider>
    </BrowserRouter>
  );
}

export default App;
